import React, { useEffect, useState, useCallback } from 'react';
import { connect } from "react-redux";
import { setSQFTAr3dPopup } from "../../../../../actions/sqftMenuFunctions";
import { generateQRCode, getUrlToCabinetGLB } from "../../../helpers/sqft3dArHelper";
import MultiLoader from "../../../../ui/multiLoader";
import store from "../../../../../store";
import { setMultiLoader } from "../../../../../actions/actionFunctions";
import ARButton from "./ARButton";
import { DEVICE_TYPE, getDeviceType } from "../../../helpers/sqftMobileHelper";
import ARButtonGoogleWebXR from "./ARButtonGoogleWebXR";

const ARWorkspace = ({ cabinetsGlb, apiErrorMessage, abortRequestController, isMobile }) => {
  const [qrImage, setQrImage] = useState(null);

  // Cleanup effect for aborting request and resetting loader
  useEffect(() => {
    return () => {
      if (abortRequestController) {
        abortRequestController.abort();
      }
      store.dispatch(setMultiLoader({ activeStep: 8, visible: false, finished: true }));
    };
  }, [abortRequestController]);

  // Generate and set QR code image
  useEffect(() => {
    const generateQRImage = async () => {
      if (!isMobile && cabinetsGlb) {
        try {
          const cabinetsInSingleModelUrl = await getUrlToCabinetGLB(cabinetsGlb);
          if (cabinetsInSingleModelUrl.s3Url) {
            const arUrl = extractARUrl(cabinetsInSingleModelUrl.s3Url);
            const imageDataUrl = await generateQRCode(arUrl);
            setQrImage(imageDataUrl);
          }
        } catch (error) {
          console.error('Error generating QR code:', error);
        }
      }
    };
    generateQRImage();
  }, [isMobile, cabinetsGlb]);

  // Extract AR URL
  const extractARUrl = (url) => {
    const regex = /composed\/(.*?)\.glb/;
    const match = url.match(regex);
    return match ? `${window.location.origin}/kitchen/#/sqft-cabinets-ar/${match[1]}` : '';
  };

  // Render AR button based on device type
  const renderArButton = useCallback(async () => {
    const cabinetsInSingleModelUrl = await getUrlToCabinetGLB(cabinetsGlb);
    if (cabinetsInSingleModelUrl.s3Url) {
      const deviceType = getDeviceType();
      return deviceType === DEVICE_TYPE.Android ? (
        <ARButtonGoogleWebXR url={cabinetsInSingleModelUrl.s3Url} />
      ) : (
        <ARButton url={cabinetsInSingleModelUrl.s3Url} />
      );
    }
    return null;
  }, [cabinetsGlb]);

  return (
    <div className="arDWorkspace">
      <div className="ar-d-workspace">
        {cabinetsGlb ? (
          isMobile ? (
            renderArButton()
          ) : (
            qrImage ? <img src={qrImage} alt="QR Code" /> : null
          )
        ) : apiErrorMessage ? (
          <div>{apiErrorMessage}</div>
        ) : (
          <MultiLoader useCabinetLoader={true} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ sqftMenuState, sqftState, serverState }) => ({
  ar3dPopup: sqftMenuState.ar3dPopup,
  cabinetsGlb: sqftState.cabinetsGlb,
  apiErrorMessage: sqftState.apiErrorMessage,
  isMobile: serverState.isMobile,
  abortRequestController: sqftState.abortRequestController,
});

const mapDispatchToProps = {
  setSQFTAr3dPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(ARWorkspace);
